module.exports = __webpack_public_path__ + "img/Puente_Istobal_MNEX25_Alto_Blanco-default-front.24a38b3d.jpg";